import { css } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import Calendar from 'assets/icons/nucleo/18px_calendar.svg'
import { StyledHeaderLabel } from './SearchBar.style'
import { SearchBarContext } from './SearchBarContext'

export const DateHeader = () => {
  const { t } = useTranslation('home')
  const { formattedDateRange } = useContext(SearchBarContext)

  return (
    <>
      <Calendar
        css={css`
          min-width: 18px;
        `}
      />
      <StyledHeaderLabel label={formattedDateRange || t('head.findRaceDate')} />
    </>
  )
}
